import { DeployPurchase, PaymentInfo, PaymentProfile } from './../interfaces/purchase.model';
import { NavbarService } from './navbar.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  MoviePurchaseBody,
  PurchaseResponseModel,
  SuscriptionPurchaseBody,
  RedeemSuscriptionBody,
  RedeemCouponResponseModel,
} from '../interfaces/purchase.model';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  baseUrl = `${environment.apiEndpoint}/Transaction`;

  objetoPurchase: DeployPurchase;

  constructor(private http: HttpClient, private auth: AuthService, private navbarService: NavbarService) { }

  purchase(body: MoviePurchaseBody): Observable<PurchaseResponseModel> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.post<PurchaseResponseModel>(`${this.baseUrl}/Purchase`, body, { headers });
  }

  purchaseSuscription(body: SuscriptionPurchaseBody): Observable<PurchaseResponseModel> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.post<PurchaseResponseModel>(`${this.baseUrl}/PurchaseSuscription`, body, {
      headers,
    });
  }

  redeemSuscriptionCoupon(body: RedeemSuscriptionBody): Observable<RedeemCouponResponseModel> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.post<RedeemCouponResponseModel>(`${this.baseUrl}/RedeemSuscriptionCoupon`, body, {
      headers,
    });
  }

  redeemFilmCoupon(body: RedeemSuscriptionBody): Observable<RedeemCouponResponseModel> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.post<RedeemCouponResponseModel>(`${this.baseUrl}/RedeemFilmCoupon`, body, {
      headers,
    });
  }

  obtenerTarjetasDePago(isppv: boolean): Promise<PaymentInfo> {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      this.http.get(environment.apiEndpoint + `/Account/GetPaymentInfo?isppv=${isppv}`, { headers }).subscribe(
        (res: PaymentInfo) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getPurchaseStatus(purchaseId: number) {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      this.http.get(environment.apiEndpoint + `/transaction/getpurchase/${purchaseId}`, { headers }).subscribe(
        (res) => resolve(res),
        (error) => reject(error),
      );
    });
  }

  eliminarTarjeta(PaymentProfileId: number) {
    return new Promise((resolve) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      let body = {
        PaymentProfileId: PaymentProfileId,
      };

      this.http.post(environment.apiEndpoint + `/account/DeletePaymentInfo`, body, { headers }).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          resolve(error);
        },
      );
    });
  }

  deployPurchase(objeto: DeployPurchase) {
    this.objetoPurchase = objeto;
    this.navbarService.modalTarjetas();
  }

  actualizarTarjetaSuscripcion(tarjeta: PaymentProfile) {
    return new Promise((resolve) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      let body = {
        subscriptionplanId: 0,
        movieId: 0,
        token: tarjeta.token,
      };

      this.http.post(environment.apiEndpoint + `/transaction/UpdateSuscriptionPayment`, body, { headers }).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          resolve(error);
        },
      );
    });
  }
}
